var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigAsterisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 580,
    height: 580,
    viewBox: "0 0 580 580",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M310.248 1H269.752V212.688L162.987 28.6115L128.013 48.8599L232.936 231.096L50.7006 126.172L30.4522 161.146L218.21 269.752H1V310.248H214.529L30.4522 417.013L50.7006 451.987L236.618 345.223L129.854 529.299L164.828 549.548L269.752 369.153V579H310.248V365.471L417.013 549.548L451.987 529.299L345.223 343.382L531.14 450.146L551.389 415.172L368.796 310.248H579V269.752H367.312L551.389 162.987L531.14 128.013L347.064 234.777L453.828 48.8599L418.853 28.6115L310.248 216.369V1Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigAsterisk);
export default __webpack_public_path__ + "static/media/big-asterisk.19a863c4a361d38e70c6415913f6ba5a.svg";
export { ForwardRef as ReactComponent };